import { IPivot } from "./types";
import { ICsvExportConfig, IXlsxExportConfig } from "@dhx/ts-grid";

// [todo] remove export() method from Pivot api and convert Exporter to class
export function getExporter(pivot: IPivot) {
	const exp = function Exporter(config: IXlsxExportConfig) {
		return pivot.grid.export.xlsx(config);
	};
	exp.csv = function(config: ICsvExportConfig) {
		return pivot.grid.export.csv(config);
	};
	exp.xlsx = function(config: IXlsxExportConfig) {
		return pivot.grid.export.xlsx(config);
	};

	return exp;
}

// export class Exporter extends Function {
// 	private _pivot: IPivot;
// 	constructor(pivot: IPivot) {
// 		this._pivot = pivot;
// 	}
// 	xlsx(config: IXlsxExportConfig) {
// 		return this._pivot.grid.export.xlsx(config);
// 	}
// 	csv(config: ICsvExportConfig) {
// 		return this._pivot.grid.export.csv(config);
// 	}
// }
